import AuthForm from "../features/auth/AuthForm";
import SignUpImg from "../../src/assets/images/SignUpImg.png";

const SignUp = () => {
  return (
    <AuthForm
      type="register"
      title="Create Account"
      subtitle="Sign up with your mobile number to get started"
      image={SignUpImg}
      redirectOnSuccess="/sign-up/complete-profile"
      footerText="Already have an account?"
      footerLink="Login"
      footerPath="/login"
      userType="CUSTOMER"
    />
  );
};

export default SignUp;
